import { FC } from "react";
import { Text } from "react-native-paper";

interface DisplayInfoProps {
  text: string;
  onPress?: () => void;
}


const DisplayInfo: FC<DisplayInfoProps> = ({
  text,
  selectable,
}) => {
  return (
    <Text
      style={{
        marginBottom: 6,
        fontSize: 14,
      }}
      selectable
    >
      { text }
    </Text>
  );
}

export default DisplayInfo;
